import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Chip, Divider, Grid2, IconButton, Link, Tooltip, Typography, useTheme } from "@mui/material";
import { useNavigate, useNavigationType, useParams } from "react-router-dom";
import { useDocumentDetailQuery } from "store/slices/apis/documentsSlice";
import moment from "moment";
import { API_END_POINT } from "config";
import AddComment from "./AddComment";
import EditDocument from "./EditDocument";
import { dispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import HistoryTimeLine from "components/HistoryTimeLine";
import { usePermission } from "hooks/usePermission";
import { ENGINEERING_DCOCUMENT_EDIT } from "config";
import { ENGINEERING_DCOCUMENT_APPROVAL } from "config";
import { ReactComponent as LeftArrowicon } from "assets/PwC_Funct_Icons_ArrowLeft_Outline_Black_RGB.svg"


const DocumentDetail = () => {
    const [workflowStatus, setWorkflowStatus] = useState('N/A');
    const theme = useTheme();
    const { projectId, documentId, assignee, isEditable } = useParams();

    const [isEditDocument, setIsEditDocument] = useState(false);
    const [rowData, setRowData] = useState(null);
    const canEdit = usePermission(ENGINEERING_DCOCUMENT_EDIT);
    const canApprove = usePermission(ENGINEERING_DCOCUMENT_APPROVAL);

    const navigate = useNavigate();
    const navigationType = useNavigationType();

    const decrypt = (encoded) => decodeURIComponent(escape(atob(encoded)));
    const decrypted = decrypt(assignee);

    const documentDetailRes = useDocumentDetailQuery({ body: { projectId: projectId }, id: documentId });

    useEffect(() => {
        if (documentDetailRes?.isSuccess) {
            if (documentDetailRes?.data?.data?.documentHistory?.length > 0) {
                let documentDetail = documentDetailRes?.data?.data?.documentHistory[0];
                setWorkflowStatus(documentDetail?.previousStatus);
            }
        }
    }, [documentDetailRes?.isSuccess])

    const handleEditDocument = (row) => {
        setIsEditDocument((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);

    };

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="h5" sx={{ fontSize: '24px', fontWeight: '500', color: '#252525', mb: 2, lineHeight: "32px", letterSpacing: '-0.4px' }}>

                        <Tooltip
                            placement="bottom"
                            title="Back"
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        >
                            {window.history.length > 1 && navigationType !== "POP" &&
                                <IconButton
                                    aria-label="download"
                                    size="small"
                                    onClick={() => {
                                        navigate(-1)
                                    }}
                                >
                                    <LeftArrowicon style={{ height: '22px', width: '22px', color: "#252525", stroke: "#252525", strokeWidth: 4 }} />
                                </IconButton>
                            }
                        </Tooltip>

                        Document Detail
                    </Typography>
                </Box>
            </Grid2>
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Grid2 size={12}>
                    <Card sx={{ borderRadius: 1, boxShadow: 'none', p: 3, pt: 1.5 }}>
                        <Box sx={{ width: '100%', mb: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: '20px',
                                    fontWeight: '500',
                                    color: '#252525',
                                    lineHeight: '32px',
                                    letterSpacing: '-0.4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                }}
                            >
                                {documentDetailRes?.data?.data?.documentName}
                                <Chip
                                    label={`${documentDetailRes?.data?.data?.documentId}`}
                                    size="small"
                                    sx={{
                                        height: '20px',
                                        color: '#fff',
                                        fontSize: '12px',
                                        backgroundColor: `${theme?.customSettings?.themeColor}`,
                                    }}
                                />
                            </Typography>
                            {/* {canEdit && isEditable == 'true' &&
                                <Tooltip
                                    placement="top"
                                    title={"Edit"}
                                    arrow
                                    slotProps={{
                                        tooltip: { sx: { fontSize: "12px" } },
                                    }}
                                >
                                    <IconButton
                                        aria-label="Edit Issue"
                                        size="small"
                                        onClick={() => handleEditDocument(documentDetailRes?.data?.data)}
                                    >
                                        <FaRegEdit />
                                    </IconButton>
                                </Tooltip>
                            } */}

                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <CardContent sx={{ p: 0 }}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
                                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>Activity name</Typography>
                                    <Typography gutterBottom variant="body2">{documentDetailRes?.data?.data?.activityName}</Typography>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
                                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>Workflow name</Typography>
                                    <Typography gutterBottom variant="body2">
                                        {documentDetailRes?.data?.data?.workFlowName}
                                    </Typography>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
                                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>Workflow status</Typography>
                                    {/* <Typography gutterBottom variant="body2">At RMC</Typography> */}
                                    <Chip size="small" sx={{
                                        fontSize: '12px',
                                        '& .MuiChip-label': {
                                            paddingLeft: '8px',
                                            paddingRight: '8px',
                                            fontWeight: 600
                                        }
                                    }} label={`${workflowStatus}`} />
                                </Grid2>

                                {/* <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
                                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>Document Name</Typography>
                                    <Typography gutterBottom variant="body2">{documentDetailRes?.data?.data?.documentName}</Typography>
                                </Grid2> */}
                                <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
                                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>Plan submission date</Typography>
                                    <Typography gutterBottom variant="body2">{moment(documentDetailRes?.data?.data?.planDate).format("MMMM D, YYYY")}</Typography>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
                                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>Document status</Typography>
                                    <Chip size="small" sx={{
                                        fontSize: '12px',
                                        '& .MuiChip-label': {
                                            paddingLeft: '8px',
                                            paddingRight: '8px',
                                            fontWeight: 600
                                        }
                                    }} label={`${documentDetailRes?.data?.data?.status}`} />
                                </Grid2>

                                <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
                                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>Last updated at</Typography>
                                    <Typography gutterBottom variant="body2">{moment(documentDetailRes?.data?.data?.updatedDate).format("MMMM D, YYYY [at] hh:mm A")}</Typography>
                                </Grid2>

                                <Grid2 size={{ xs: 12, md: 12, lg: 12 }}>
                                    <Link
                                        component="button"
                                        variant="body2"
                                        onClick={() => {
                                            window.open(`${API_END_POINT}issues/view/${documentDetailRes?.data?.data?.docFileName}`, '_blank');
                                        }}
                                    >
                                        View Document
                                    </Link>
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <HistoryTimeLine id={documentId} workflow={setWorkflowStatus} />
                    {/* <Card sx={{ borderRadius: 1, boxShadow: 'none', p: 3, pt: 1.5, minHeight: '250px' }}>
                        <Box sx={{ width: '100%', mb: 1.5 }}>
                            <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '500', color: '#252525', lineHeight: "32px", letterSpacing: '-0.4px' }}>
                                History
                            </Typography>
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <CardContent sx={{ p: 0 }}>
                            {documentDetailRes?.data?.data?.documentHistory?.length > 0 ?
                                <Timeline
                                    sx={{
                                        [`& .${timelineOppositeContentClasses.root}`]: {
                                            flex: 0.3,
                                        },
                                    }}
                                >
                                    {documentDetailRes?.data?.data?.documentHistory?.map((val, index) => {
                                        return (
                                            <TimelineItem>
                                                <TimelineOppositeContent
                                                    sx={{ m: 'auto 0' }}
                                                    align="right"
                                                    variant="body2"
                                                    color="text.secondary"
                                                >
                                                    {moment(val?.createdDate).format("MMMM D, YYYY [at] hh:mm A")}
                                                </TimelineOppositeContent>
                                                <TimelineSeparator>
                                                    <TimelineConnector />
                                                    <TimelineDot sx={{
                                                        padding: '0px', boxShadow: 'none', margin: "6.5px 0px", borderStyle: 'none', backgroundColor: "inherit"
                                                    }}>
                                                        <Avatar {...stringAvatar(val?.userName)} />
                                                    </TimelineDot>
                                                    <TimelineConnector />
                                                </TimelineSeparator>
                                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                                    <Typography variant="h6" component="span" sx={{
                                                        fontWeight: 600, fontSize: '16px'
                                                    }}>
                                                        {val?.userName}
                                                    </Typography>
                                                    <Breadcrumbs
                                                        separator={<FaArrowRight fontSize="small" />}
                                                        aria-label="status transition"
                                                    >
                                                        <Chip
                                                            label={val?.previousStatus}
                                                            variant="outlined"
                                                            sx={{ fontWeight: 'bold', borderColor: '#1976d2', color: '#212121', borderRadius: '4px', height: '20px' }}
                                                        />
                                                        <Chip
                                                        label={val?.currentStatus}
                                                        variant="outlined"
                                                        sx={{ borderColor: '#1976d2', color: '#212121', borderRadius: '4px', height: '20px' }}
                                                    />
                                                    </Breadcrumbs>
                                                    <Typography sx={{ fontSize: '14px' }}>{val?.comment}</Typography>
                                                </TimelineContent>
                                            </TimelineItem>
                                        )
                                    })

                                    }
                                </Timeline>

                                : <Typography variant="caption" sx={{ textAlign: 'center' }}>

                                    Record not found.
                                </Typography>
                            }

                        </CardContent>
                    </Card> */}
                </Grid2>
                {canApprove && decrypted == 'edit' &&
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Card sx={{ borderRadius: 1, boxShadow: 'none', p: 3, pt: 1.5, minHeight: '250px' }}>
                            <Box sx={{ width: '100%', mb: 1.5 }}>
                                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '500', color: '#252525', lineHeight: "32px", letterSpacing: '-0.4px' }}>
                                    Add comment
                                </Typography>
                            </Box>
                            <Divider sx={{ mb: 2 }} />
                            <CardContent sx={{ p: 0 }}>
                                <AddComment id={documentId} />
                            </CardContent>
                        </Card>
                    </Grid2>
                }

            </Grid2>
            {isEditDocument &&
                <EditDocument open={isEditDocument} cancelIssue={handleEditDocument} rowData={rowData} openNotification={openNotification} />
            }

        </>
    );
}

export default DocumentDetail;
